<main>
    <div>
        <div class="eventList-head">
            <div class="header-text eventList-text">
                Event Attended
            </div>
        </div>

        <div class="table-card">
            <app-table [columns]="columns" [data]="data" [loading]="loading">
            </app-table>
        </div>
    </div>
</main>